<p-table #datatable [columns]="columns" [value]="_items" responsiveLayout="scroll" [rows]="rows" [first]="first"
    [rowsPerPageOptions]="rowsPerPageOptions" [showCurrentPageReport]="true" [paginator]="paginator"
    paginatorDropdownAppendTo="body"
    [currentPageReportTemplate]="'components.global.datatable.currentPageReportTemplate' | translate"
    [scrollable]="true" [scrollHeight]="scrollHeight" [lazy]="lazy" [totalRecords]="paginatorModel?.totalElements || 0"
    [(selection)]="itemsSelect" [selectionMode]="selectionMode" (selectionChange)="onSelectionChange($event)"
    [selectAll]="selectAll" (selectAllChange)="onSelectAllChange($event)" (onLazyLoad)="onLoadItemsAction($event)"
    [rowHover]="true" [dataKey]="dataKey" styleClass="p-databale-sticky p-datatable-striped" [loading]="loading"
    [resizableColumns]="true" columnResizeMode="expand" (onRowSelect)="rowSelectOnAction($event)" 
    (onRowUnselect)="rowUnselectOnAction($event)" [(expandedRowKeys)]="expandedRowKeys"
    [rowSelectable]="isRowSelectableOnAction.bind(this)">
    <ng-template pTemplate="caption">
        <div class="grid grid-cols-12 gap-4">
            <div class="col-span-12 flex align-items-end" [ngClass]="{'md:col-span-6': showFilter}">
                <h5 class="m-0 table-caption">{{captionText | translate}}</h5>
            </div>
            <div class="col-span-12 md:col-span-6" *ngIf="showFilter">
                <div class="p-inputgroup">
                    <input id="txt-search" name="txt-search" type="text" pInputText
                        [placeholder]="'placeholders.inputs.search' | translate"
                        [(ngModel)]="query" (keydown.enter)="onFilterItemsOnAction()" maxlength="255"
                        class="w-100">
                    <button type="button" pButton pRipple icon="pi pi-search"
                        (click)="onFilterItemsOnAction()" [pTooltip]="'tooltips.search' | translate"
                        tooltipPosition="top"></button>
                    <button type="button" pButton icon="pi pi-filter" class="p-button-outlined"
                        [pTooltip]="'tooltips.filtersAdvanced' | translate" tooltipPosition="top"
                        (click)="openFiltersSidebarOnAction()"
                        *ngIf="showAdvancedFilter"></button>
                </div>
            </div>
        </div>
    </ng-template>
    <ng-template
        pTemplate="header"
        let-columns>
        <tr>
            <th #expandedCol style="width: 10px; text-align: center;" alignFrozen="left" pFrozenColumn [frozen]="true"
                *ngIf="showRowExpansion">
                <button type="button" pButton pRipple (click)="expandedAllRowsOnAction(expandedCol)"
                    class="p-button-text p-button-rounded p-button-plain"
                    [icon]="isExpandedAllRows ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
                    [pTooltip]="getTooltipBtnExpandedAllRows() | translate"
                    tooltipPosition="top">
                </button>
            </th>
            <th style="width: 40px; min-width: 40px; max-width: 40px;" alignFrozen="left" pFrozenColumn [frozen]="true"
                *ngIf="selectionMode === 'multiple'">
                <p-tableHeaderCheckbox name="check-header"
                    [disabled]="isAllRowsCheckboxSelectDisabledOnAction()">
                </p-tableHeaderCheckbox>
            </th>
            <ng-container *ngFor="let col of columns">
                <ng-template [ngIf]="!col.invisible && (!col.isFrozenColumn || isMobile())">
                    <th [pSortableColumn]="col.sortable === 'true' ? col.nameAttrSortable ? col.nameAttrSortable : col.nameAttr : ''"
                        [style]="col.style">
                        {{col.label}}
                        <p-sortIcon *ngIf="col.sortable === 'true'"
                            [field]="col.nameAttrSortable ? col.nameAttrSortable : col.nameAttr"></p-sortIcon>
                    </th>
                </ng-template>
                <!--FrozenColumn-->
                <ng-template [ngIf]="!col.invisible && col.isFrozenColumn && !isMobile()">
                    <th [pSortableColumn]="col.sortable === 'true' ? col.nameAttrSortable ? col.nameAttrSortable : col.nameAttr : ''"
                        [alignFrozen]="col.frozenColumnAlign" pFrozenColumn [frozen]="true"
                        [style]="col.style" [ngStyle]="{'left': col.frozenLeftStartPos || 'auto', 'right': col.frozenRightStartPos || 'auto'}">
                        {{col.label}}
                        <p-sortIcon *ngIf="col.sortable === 'true'"
                            [field]="col.nameAttrSortable ? col.nameAttrSortable : col.nameAttr"></p-sortIcon>
                    </th>
                </ng-template>
            </ng-container>
            <th [style]="styleColumnActions" class="!text-center" alignFrozen="right"
                pFrozenColumn *ngIf="showColumnActions">
                {{'labels.acoes' | translate}}
            </th>
        </tr>
    </ng-template>
    <ng-template
        pTemplate="body"
        let-item
        let-columns="columns"
        let-editing="editing"
        let-index="rowIndex"
        let-expanded="expanded">
        <tr [style]="getStyleRowConditional(item)" [pSelectableRow]="item"
            [ngClass]="['row-datatable-' + index + '-request-focus-' + requestFocusOnLoadItems, requestFocusOnLoadItems ? 'row-datatable-request-focus' : '']">
            <td #expandedCol style="width: 10px; text-align: center;" alignFrozen="left" pFrozenColumn
                *ngIf="showRowExpansion">
                <button type="button" pButton pRipple (click)="rowExpansionOnAction(item, expandedCol)"
                    class="p-button-text p-button-rounded p-button-plain"
                    [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
                    [pTooltip]="getTooltipBtnExpandedRow(expanded) | translate">
                </button>
            </td>
            <td style="width: 40px; min-width: 40px; max-width: 40px;" *ngIf="selectionMode === 'multiple'"
                alignFrozen="left" pFrozenColumn>
                <p-tableCheckbox [pSelectableRow]="item" [value]="item" [name]="'check-' + index"
                    tooltipPosition="top" [disabled]="isRowCheckboxSelectDisabledOnAction(item)">
                </p-tableCheckbox>
            </td>
            <ng-container *ngFor="let col of columns; let indexCol = index;">
                <!-- Columns Editable -->
                <ng-template [ngIf]="col.editable">
                    <td [style]="col.style" [pEditableColumn]="item[col.nameAttr]" pEditableColumnField="col.nameAttr">
                        <!-- <span class="p-column-title">{{col.label}}</span> -->
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <!-- Type Text -->
                                <ng-template [ngIf]="col.fieldType === 'TEXT'">
                                    <input pInputText type="text" [(ngModel)]="item[col.nameAttr]"
                                        [name]="'text' + col.nameAttr + item.id" class="w-full"
                                        app-input-uppercase [required]="col.required"
                                        (onFocus)="selectAllTextWithDelay($event, 100); onFocusAction(item);"
                                        (onBlur)="onCellEditingOnAction(item, index, col)"
                                        (keydown.enter)="onCellEditingOnAction(item, index, col)"
                                        [disabled]="isCellDisabledOnAction(item, col)" />
                                </ng-template>
                                <!-- Type Text Not Upper Case -->
                                <ng-template [ngIf]="col.fieldType === 'TEXT_NOT_UPPERCASE'">
                                    <input pInputText type="text" [(ngModel)]="item[col.nameAttr]"
                                        [name]="'text' + col.nameAttr + item.id"
                                        [required]="col.required" class="w-full"
                                        (onFocus)="selectAllTextWithDelay($event, 100); onFocusAction(item);"
                                        (onBlur)="onCellEditingOnAction(item, index, col)"
                                        (keydown.enter)="onCellEditingOnAction(item, index, col)"
                                        [disabled]="isCellDisabledOnAction(item, col)" />
                                </ng-template>
                                <!-- Type Number -->
                                <ng-template [ngIf]="col.fieldType === 'NUMBER'">
                                    <input pInputText type="text" [(ngModel)]="item[col.nameAttr]"
                                        [name]="'number' + col.nameAttr + item.id"
                                        app-input-numbers [required]="col.required"
                                        (onFocus)="selectAllTextWithDelay($event, 100); onFocusAction(item);"
                                        (onBlur)="onCellEditingOnAction(item, index, col)"
                                        (keydown.enter)="onCellEditingOnAction(item, index, col)"
                                        class="w-full" [disabled]="isCellDisabledOnAction(item, col)" />
                                </ng-template>
                                <!-- Type Number Decimal -->
                                <ng-template [ngIf]="col.fieldType === 'NUMBER_DECIMAL'">
                                    <p-inputNumber
                                        [id]="'numberDecimal' + col.nameAttr + item.id"
                                        [name]="'numberDecimal' + col.nameAttr + item.id"
                                        [(ngModel)]="item[col.nameAttr]"
                                        [placeholder]="
                                            'placeholders.inputs.decimal' | translate
                                        "
                                        [minFractionDigits]="col.minFractionDigits || 2"
                                        [maxFractionDigits]="col.maxFractionDigits || 4"
                                        [locale]="'locale' | translate"
                                        [required]="col.required"
                                        class="text-right w-full"
                                        (onFocus)="selectAllTextWithDelay($event, 100); onFocusAction(item);"
                                        (onBlur)="onCellEditingOnAction(item, index, col)"
                                        (keydown.enter)="onCellEditingOnAction(item, index, col)"
                                        step="0" [disabled]="isCellDisabledOnAction(item, col)">
                                    </p-inputNumber>
                                </ng-template>
                                <!-- Type Money -->
                                <ng-template [ngIf]="col.fieldType === 'MONEY'">
                                    <p-inputNumber
                                        [id]="'money' + col.nameAttr + item.id"
                                        [name]="'money' + col.nameAttr + item.id"
                                        [(ngModel)]="item[col.nameAttr]"
                                        [placeholder]="
                                            'placeholders.inputs.money' | translate
                                        "
                                        [prefix]="'labels.prefixMoney' | translate"
                                        [minFractionDigits]="col.minFractionDigits || 2"
                                        [maxFractionDigits]="col.maxFractionDigits || 4"
                                        [locale]="'locale' | translate"
                                        [required]="col.required"
                                        (onFocus)="selectAllTextWithDelay($event, 100); onFocusAction(item);"
                                        (onBlur)="onCellEditingOnAction(item, index, col)"
                                        (keydown.enter)="onCellEditingOnAction(item, index, col)"
                                        class="text-right w-full"
                                        step="0" [disabled]="isCellDisabledOnAction(item, col)">
                                    </p-inputNumber>
                                </ng-template>
                                <!-- Type Mask -->
                                <ng-template [ngIf]="col.fieldType === 'MASK'">
                                    <p-inputMask type="tel" [(ngModel)]="item[col.nameAttr]" [name]="'mask' + col.nameAttr + item.id"
                                        [mask]="col.mask" [required]="col.required" class="w-full"
                                        (onFocus)="selectAllTextWithDelay($event, 100)"
                                        (onBlur)="onCellEditingOnAction(item, index, col)"
                                        (keydown.enter)="onCellEditingOnAction(item, index, col)"
                                        [disabled]="isCellDisabledOnAction(item, col)">
                                    </p-inputMask>
                                </ng-template>
                                <!-- Type Select Options -->
                                <ng-template [ngIf]="col.fieldType === 'SELECT_OPTIONS'">
                                    <p-select [name]="'dropdown' + col.nameAttr + item.id" [options]="col.options"
                                        [filter]="true" filterMatchMode="contains"
                                        [(ngModel)]="item[col.nameAttr]" optionLabel="label"
                                        optionValue="value" appendTo="body"
                                        [emptyMessage]="'messages.warn.selectEmptyMessage' | translate"
                                        [emptyFilterMessage]="'messages.warn.selectEmptyMessage' | translate"
                                        [placeholder]="'placeholders.select' | translate"
                                        [required]="col.required" styleClass="w-full"
                                        (onFocus)="onFocusAction(item, index)"
                                        (onChange)="onCellEditingOnAction(item, index, col)"
                                        [disabled]="isCellDisabledOnAction(item, col)">
                                    </p-select>
                                </ng-template>
                                <!-- Type Multi Select Options -->
                                <ng-template [ngIf]="col.fieldType === 'MULTI_SELECT_OPTIONS'">
                                    <p-multiSelect [name]="'multi-select' + col.nameAttr + item.id" [options]="col.options"
                                        styleClass="w-full" appendTo="body"
                                        [(ngModel)]="item[col.nameAttr]" optionLabel="label"
                                        optionValue="value" [required]="col.required" display="chip"
                                        [emptyMessage]="'messages.warn.selectEmptyMessage' | translate"
                                        [emptyFilterMessage]="'messages.warn.selectEmptyMessage' | translate"
                                        [placeholder]="'placeholders.select' | translate"
                                        [selectedItemsLabel]="'placeholders.selectedItemsLabel' | translate"
                                        [virtualScroll]="true"
                                        [virtualScrollItemSize]="43"
                                        (onFocus)="onFocusAction(item, index)"
                                        (onChange)="onCellEditingOnAction(item, index, col)"
                                        [disabled]="isCellDisabledOnAction(item, col)">
                                    </p-multiSelect>
                                </ng-template>
                            </ng-template>
                            
                            <ng-template pTemplate="output">
                                <ng-container *ngIf="item">
                                    <div [innerHTML]="getAdapterColumnRender(indexCol, item)"></div>
                                </ng-container>
                            </ng-template>
                        </p-cellEditor>
                    </td>
                </ng-template>
                <!-- Columns Not Editables -->
                <ng-template [ngIf]="!col.editable && !col.invisible && (!col.isFrozenColumn || isMobile())">
                    <td [style]="col.style">
                        <!-- <span class="p-column-title">{{col.label}}</span> -->
                        <ng-container *ngIf="item">
                            <div [innerHTML]="getAdapterColumnRender(indexCol, item)"></div>
                        </ng-container>
                    </td>
                </ng-template>
                <!--FrozenColumn-->
                <ng-template [ngIf]="!col.editable && !col.invisible && (col.isFrozenColumn && !isMobile())">
                    <td [style]="col.style" [alignFrozen]="col.frozenColumnAlign" pFrozenColumn [frozen]="true"
                        [style]="col.style" [ngStyle]="{'left': col.frozenLeftStartPos || 'auto', 'right': col.frozenRightStartPos || 'auto'}">
                        <!-- <span class="p-column-title">{{col.label}}</span> -->
                        <ng-container *ngIf="item">
                            <div [innerHTML]="getAdapterColumnRender(indexCol, item)"></div>
                        </ng-container>
                    </td>
                </ng-template>
            </ng-container>
            <td [style]="styleColumnActions" class="!text-center" alignFrozen="right"
                pFrozenColumn [frozen]="true" *ngIf="showColumnActions">
                <ng-container
                    [ngTemplateOutlet]="contentColumnActions"
                    [ngTemplateOutletContext]="{item: item, index: index}">
                </ng-container>
            </td>
        </tr>
    </ng-template>

    <ng-template pTemplate="expandedrow" let-item>
        <tr>
            <td [attr.colspan]="getQuantityColumns()" style="padding: 20px;">
                <ng-container
                    [ngTemplateOutlet]="contentRowExpanded"
                    [ngTemplateOutletContext]="{item: item, table: datatable}">
                </ng-container>
            </td>
        </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
        <tr>
            <td [attr.colspan]="getQuantityColumns()">
                <span>{{'components.global.datatable.emptyMessage' | translate}}</span>
            </td>
        </tr>
    </ng-template>

    <ng-template pTemplate="summary" *ngIf="showExports">
        <div class="flex">
            <button type="button" pButton pRipple icon="pi pi-file" class="mr-2"
                [pTooltip]="'tooltips.exportarCsv' | translate" tooltipPosition="bottom"
                (click)="export(exporterType.CSV)" [disabled]="hasEntitiesLessThanOrEqualToZero()">
            </button>
            <button type="button" pButton pRipple icon="pi pi-file-excel" class="mr-2"
                [pTooltip]="'tooltips.exportarExcel' | translate" tooltipPosition="bottom"
                (click)="export(exporterType.EXCEL)" [disabled]="hasEntitiesLessThanOrEqualToZero()"
                severity="success">
            </button>
            <button type="button" pButton pRipple icon="pi pi-file-pdf" class="mr-2"
                [pTooltip]="'tooltips.exportarPdf' | translate" tooltipPosition="bottom"
                (click)="export(exporterType.PDF)" [disabled]="hasEntitiesLessThanOrEqualToZero()"
                severity="warn">
            </button>
        </div>
    </ng-template>
</p-table>